import { createSlice } from "@reduxjs/toolkit";

const mastersCategoryFilterSlice = createSlice({
  name: "mastersCategoryFilter",
  initialState: {
    category: null,
    brand: null,
    model: null,
    part_name: null,
  },
  reducers: {
    setCategory: (state, action) => {
      state.category = action.payload.category;
    },

    setFilters: (state, action) => {
      if ("brand" in action.payload) state.brand = action.payload.brand;
      if ("model" in action.payload) state.model = action.payload.model;
      if ("part_name" in action.payload) state.part_name = action.payload.part_name;
    },

    // ⭐ RESET ONLY ONE FILTER  
    resetFilter: (state, action) => {
      const key = action.payload; // "brand" or "model" or "part_name"
      if (state.hasOwnProperty(key)) {
        state[key] = null;
      }
    },

    clearFilters: (state) => {
      state.brand = null;
      state.model = null;
      state.part_name = null;
    },
  },
});

export const {
  setCategory,
  setFilters,
  clearFilters,
  resetFilter
} = mastersCategoryFilterSlice.actions;

export const selectMastersCategoryFilterState = (state) =>
  state.mastersCategoryFilter;

export default mastersCategoryFilterSlice.reducer;
